"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHorizontalResize = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = require("react");
const useHorizontalResize = function () {
  let {
    initialWidth = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [width, setWidth] = (0, _react.useState)(initialWidth);
  const {
    ref
  } = (0, _lodestarUtils.useResizeObserver)((0, _react.useCallback)(entry => {
    const newHorizontalSize = entry[0].borderBoxSize[0].inlineSize;
    if (newHorizontalSize) {
      setWidth(newHorizontalSize);
    }
  }, []));
  return {
    ref,
    width
  };
};
exports.useHorizontalResize = useHorizontalResize;
//# sourceMappingURL=useHorizontalResize.js.map